<template>
  <el-form class="password-rest-form">
    <el-form-item v-if="requireOldPassword" class="password-field">
      <password
        placeholder="Confirm old password"
        v-model="oldPassword"
        class="password-reset-form"
        id="old-password"
      ></password>
    </el-form-item>
    <el-form-item class="password-field">
      <password
        class="password"
        placeholder="Enter new password"
        v-model="newPassword"
        id="new-password"
      ></password>
      <span class="hint">Minimum 8 Characters</span>
    </el-form-item>
    <el-form-item class="password-field">
      <password
        placeholder="Confirm new password"
        v-model="confirmedPassword"
        class="password-reset-form"
        id="confirm-password"
      ></password>
    </el-form-item>
    <el-button
      class="password-reset-btn"
      @click="onResetPassword"
      type="primary"
      :disabled="isDisabled"
    >Change password</el-button>
  </el-form>
</template>

<script>
import Password from 'vue-password-strength-meter';

export default {
  name: 'PasswordOnlyResetForm',
  components: {
    Password,
  },
  props: {
    requireOldPassword: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {
    this.token = this.$route.params.token;
  },
  data: () => ({
    oldPassword: null,
    newPassword: null,
    confirmedPassword: null,
    token: null,
  }),
  computed: {
    isDisabled() {
      let disable = true;
      if (
        this.newPassword !== null &&
        this.confirmedPassword !== null &&
        this.newPassword === this.confirmedPassword &&
        this.confirmedPassword.length >= 8
      ) {
        this.$message({
          type: 'success',
          message: 'Passwords match, click Reset password',
        });
        disable = false;
      }

      if ((this.oldPassword === null || this.oldPassword === '') && this.requireOldPassword) {
        disable = true;
      }

      return disable;
    },
  },
  methods: {
    onResetPassword() {
      const data = {
        password: this.confirmedPassword,
        user: this.$store.state.user.me.id,
        token: this.token,
        oldPassword: this.oldPassword,
      };
      if (this.token === null || this.token === undefined) {
        this.$store.dispatch('auth/updatePassword', data);
      } else {
        this.$store.dispatch('auth/tokenPasswordReset', data);
      }
      this.clearRestForm();
      this.hideResetPasswordDialog();
    },
    clearRestForm() {
      this.oldPassword = null;
      this.newPassword = null;
      this.confirmedPassword = null;
    },
    hideResetPasswordDialog() {
      this.$emit('togglePasswordDialog');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.password-reset-btn {
  width: 100%;
  background: $colony-primary;
  border-color: $colony-primary;
  border-radius: 0;
}
.password-rest-form {
  margin: auto;
  width: 100%;
}
.hint {
  font-size: 10px;
  padding: 1px;
  color: gray;
}
.password-field .Password {
  max-width: 100%;
  margin: 0 auto;
}
.password-field .Password__field {
  border-radius: 2px;
  box-sizing: border-box;
  font-size: 14px;
  padding: 5px;
  width: 50%;
}
.password-field .Password__badge {
  float: right;
  position: relative;
  bottom: 33px;
  right: 8px;
  color: #fff;
  border-radius: 3px;
  padding: 3px;
  width: 20px;
  height: 20px;
  font-size: 10px;
  line-height: 1.1;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// PasswordOnlyResetForm.vue?2c9e7f07